import { __awaiter, __generator } from "tslib";
import { getComponentId } from '../../../utils';
import { encode } from './WixStyleColors';
import { decodeWixStyles } from './decodeWixStyles';
var WixStyles = /** @class */ (function () {
    function WixStyles(SDKAdapter, editorSDKAdapter) {
        var _this = this;
        this.refresh = function () { return __awaiter(_this, void 0, void 0, function () {
            var compRef, styles;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!((_a = this.editorSDKAdapter) === null || _a === void 0 ? void 0 : _a.instance)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.editorSDKAdapter.instance.components.getById('token', {
                                id: getComponentId(),
                            })];
                    case 1:
                        compRef = _b.sent();
                        return [4 /*yield*/, this.editorSDKAdapter.instance.document.tpa.getStyleParams('token', {
                                compRef: compRef,
                            })];
                    case 2:
                        styles = _b.sent();
                        return [2 /*return*/, this.normalizeStylesReceivedFromEditorSDK(styles)];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.decode = function (params, siteColors, textPresets) {
            if (!params) {
                return null;
            }
            return decodeWixStyles(params, siteColors, textPresets);
        };
        this.SDKAdapter = SDKAdapter;
        this.editorSDKAdapter = editorSDKAdapter;
    }
    WixStyles.prototype.setBooleanParam = function (key, value, options) {
        this.SDKAdapter.setBooleanParam(key, value, options);
    };
    WixStyles.prototype.setFontParam = function (key, value, options) {
        this.SDKAdapter.setFontParam(key, value, options);
    };
    WixStyles.prototype.setNumberParam = function (key, value, options) {
        this.SDKAdapter.setNumberParam(key, value, options);
    };
    WixStyles.prototype.setColorParam = function (key, value, options) {
        return __awaiter(this, void 0, void 0, function () {
            var siteColors, color;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.SDKAdapter.getSiteColors()];
                    case 1:
                        siteColors = _a.sent();
                        color = encode(value, siteColors);
                        this.SDKAdapter.setColorParam(key, color, options);
                        return [2 /*return*/];
                }
            });
        });
    };
    WixStyles.prototype.setStringParam = function (key, value, options) {
        this.editorSDKAdapter.setStringParam(key, value, options);
    };
    WixStyles.prototype.load = function () {
        return this.SDKAdapter.getStyleParams();
    };
    WixStyles.prototype.getSiteTextPresets = function () {
        return this.SDKAdapter.getSiteTextPresets();
    };
    WixStyles.prototype.getSiteColors = function () {
        return this.SDKAdapter.getSiteColors();
    };
    WixStyles.prototype.normalizeStylesReceivedFromEditorSDK = function (styles) {
        return __awaiter(this, void 0, void 0, function () {
            var _loop_1, this_1, _a, _b, _c, _i, color;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _loop_1 = function (color) {
                            var siteColors, siteColor;
                            return __generator(this, function (_e) {
                                switch (_e.label) {
                                    case 0:
                                        if (!(styles.colors.hasOwnProperty(color) &&
                                            styles.colors[color].hasOwnProperty('themeName'))) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this_1.getSiteColors()];
                                    case 1:
                                        siteColors = _e.sent();
                                        siteColor = siteColors.find(function (sc) { return sc.name === styles.colors[color].themeName; });
                                        styles.colors[color].themeName = siteColor.reference;
                                        _e.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _a = styles.colors;
                        _b = [];
                        for (_c in _a)
                            _b.push(_c);
                        _i = 0;
                        _d.label = 1;
                    case 1:
                        if (!(_i < _b.length)) return [3 /*break*/, 4];
                        _c = _b[_i];
                        if (!(_c in _a)) return [3 /*break*/, 3];
                        color = _c;
                        return [5 /*yield**/, _loop_1(color)];
                    case 2:
                        _d.sent();
                        _d.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, styles];
                }
            });
        });
    };
    return WixStyles;
}());
export { WixStyles };
//# sourceMappingURL=WixStyles.js.map